import * as Types from "../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateBankAccountMutationVariables = Types.Exact<{
  currency_book_id: Types.Scalars["Int"];
  currencyId: Types.Scalars["Int"];
  bank_id: Types.Scalars["Int"];
  product_type: Types.Product_Types_Enum_Enum;
  opening_interest_rate?: Types.Maybe<Types.Scalars["numeric"]>;
  notice_days?: Types.Maybe<Types.Scalars["Int"]>;
  fixed_maturity_date?: Types.Maybe<Types.Scalars["date"]>;
  account_id?: Types.Maybe<Types.Scalars["String"]>;
  account_description?: Types.Maybe<Types.Scalars["String"]>;
  organisation_id: Types.Scalars["Int"];
}>;

export type CreateBankAccountMutation = { __typename?: "mutation_root" } & {
  insert_bank_accounts_one?: Types.Maybe<
    { __typename?: "bank_accounts" } & Pick<Types.Bank_Accounts, "account_id">
  >;
};

export const CreateBankAccountDocument = gql`
  mutation CreateBankAccount(
    $currency_book_id: Int!
    $currencyId: Int!
    $bank_id: Int!
    $product_type: product_types_enum_enum!
    $opening_interest_rate: numeric
    $notice_days: Int
    $fixed_maturity_date: date
    $account_id: String
    $account_description: String
    $organisation_id: Int!
  ) {
    insert_bank_accounts_one(
      object: {
        bank_id: $bank_id
        currency_book_id: $currency_book_id
        fixed_maturity_date: $fixed_maturity_date
        notice_days: $notice_days
        opening_interest_rate: $opening_interest_rate
        currency_id: $currencyId
        account_description: $account_description
        account_id: $account_id
        product_type: $product_type
        organisation_id: $organisation_id
      }
    ) {
      account_id
    }
  }
`;

export function useCreateBankAccountMutation() {
  return Urql.useMutation<
    CreateBankAccountMutation,
    CreateBankAccountMutationVariables
  >(CreateBankAccountDocument);
}
